/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HTMLData
 */
export interface HTMLData {
    /**
     * 
     * @type {string}
     * @memberof HTMLData
     */
    html?: string;
    /**
     * 
     * @type {string}
     * @memberof HTMLData
     */
    metadata?: string;
}

/**
 * Check if a given object implements the HTMLData interface.
 */
export function instanceOfHTMLData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HTMLDataFromJSON(json: any): HTMLData {
    return HTMLDataFromJSONTyped(json, false);
}

export function HTMLDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HTMLData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'html': !exists(json, 'html') ? undefined : json['html'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
    };
}

export function HTMLDataToJSON(value?: HTMLData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'html': value.html,
        'metadata': value.metadata,
    };
}

